export const arePropsNonEmpty = <T>(props: T): props is NonNullable<T> =>
  Boolean(props && Object.keys(props).length);
